/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_Confirmation_OverdueInputs */

const en_queue_sos_confirmation_overdue = /** @type {(inputs: Queue_Sos_Confirmation_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order confirmations not answered in time`)
};

/**
* | output |
* | --- |
* | "Order confirmations not answered in time" |
*
* @param {Queue_Sos_Confirmation_OverdueInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_confirmation_overdue = /** @type {((inputs?: Queue_Sos_Confirmation_OverdueInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_Confirmation_OverdueInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_confirmation_overdue(inputs)
});